import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";

import PageContentLoader from "../components/TableLoader";
import { getPrice, updatePrice } from "../../services/UserServices/UserService";
import PageTitle from "../layouts/PageTitle";

const Price = () => {
  const [loading, setLoading] = useState(true);
  const [id, setId] = useState(null);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [formData, setFormData] = useState({
    jobFeaturedCharge: "",
    serviceFeaturedCharge: "",
    standerdJobPrice: "",
    standerdServicePrice: "",
    subCategoryJobCharge: "",
    subCategoryServiceCharge: "",
    urgentCharge: "",
  });

  const [editableFields, setEditableFields] = useState({
    jobFeaturedCharge: false,
    serviceFeaturedCharge: false,
    standerdJobPrice: false,
    standerdServicePrice: false,
    subCategoryJobCharge: false,
    subCategoryServiceCharge: false,
    urgentCharge: false,
  });

  async function handleTableList() {
    setLoading(true);
    try {
      const res = await getPrice();
      setFormData({
        jobFeaturedCharge: res?.data?.data?.data[0]?.jobFeaturedCharge,
        serviceFeaturedCharge: res?.data?.data?.data[0]?.serviceFeaturedCharge,
        standerdJobPrice: res?.data?.data?.data[0]?.standerdJobPrice,
        standerdServicePrice: res?.data?.data?.data[0]?.standerdServicePrice,
        subCategoryJobCharge: res?.data?.data?.data[0]?.subCategoryJobCharge,
        subCategoryServiceCharge:
          res?.data?.data?.data[0]?.subCategoryServiceCharge,
        urgentCharge: res?.data?.data?.data[0]?.urgentCharge,
      });
      setId(res?.data?.data?.data[0]?._id);
      setLoading(false);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    handleTableList();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const toggleEdit = (field) => {
    setEditableFields((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingSubmit(true);
    try {
      const res = await updatePrice({ ...formData, jobSettingsId: id });
      toast.success(res?.data?.message);
    } catch (error) {
      toast.error(error?.response?.data?.message);
    } finally {
      setLoadingSubmit(false);
    }
  };

  if (loading)
    return (
      <div className="qx-page">
        <PageTitle pageTitle="Edit Price" />
        <div className="d-flex justify-content-center py-5">
        <PageContentLoader message="Loading pricing..." />
        </div>
      </div>
    );

  const renderField = (label, fieldName) => (
    <div className="mb-3 d-flex align-items-end gap-3">
      <div className="flex-grow-1">
        <label className="form-label">{label}</label>
        <input
          type="text"
          name={fieldName}
          className="form-control"
          value={formData[fieldName]}
          onChange={handleChange}
          readOnly={!editableFields[fieldName]}
        />
      </div>
      <button
        type="button"
        className="btn btn-outline-secondary"
        onClick={() => toggleEdit(fieldName)}
        style={{ height: "44px", borderRadius: "8px" }}
      >
        {editableFields[fieldName] ? "Lock" : "Edit"}
      </button>
    </div>
  );

  return (
    <div className="qx-page">
      <PageTitle pageTitle="Edit Price" subtitle="Configure platform pricing and featured charges" />
      <div className="qx-section-card">
        <form onSubmit={handleSubmit}>
          {renderField("Job Featured Charge", "jobFeaturedCharge")}
          {renderField("Service Featured Charge", "serviceFeaturedCharge")}
          {renderField("Standerd Job Price", "standerdJobPrice")}
          {renderField("Standerd Service Price", "standerdServicePrice")}
          {renderField("Sub Category Job Charge", "subCategoryJobCharge")}
          {renderField("Sub Category Service Charge", "subCategoryServiceCharge")}
          {renderField("Urgent Charge", "urgentCharge")}
          <button
            type="submit"
            className="btn btn-primary qx-btn-brand mt-2"
          >
            {loadingSubmit ? "Loading..." : "Save all changes"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Price;
